import ComponentLayout from "../../../../src/layouts/component-layout";
import { ButtonSizes } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  ButtonSizes,
  PropTableValues,
  React
};